let mutations = {
    userInit(state, data) {
        console.log(data,123)
        if (data.is_new) {
            state.is_new = data.is_new;
            state.user_state = data.state;
        } else {
            // 不是新用户
            state.is_new = false;
            state.is_complete = data.data.user_info_complete;
            state.user_state = data.state;
            state.headimg = data.data ? data.data.head_pic : '';
            state.name = data.data ? data.data.name : '';
            state.phone = data.data ? data.data.phone : '';
            state.province_id = data.data && data.data.province ? data.data.province.province_id : '';
            let province_name = data.data && data.data.province ? data.data.province.province_name : '';
            state.province_name = province_name ? province_name : '';
            state.city_id = data.data && data.data.city ? data.data.city.city_id : '';
            let city_name = data.data && data.data.city ? data.data.city.city_name : '';
            state.city_name = city_name ? city_name : '';
            state.sex = data.data ? data.data.sex : '';
            state.grade = data.data && data.data.grade ? data.data.grade.grade_code : '';
            state.email = data.data ? data.data.email : '';
            state.uid = data.data ? data.data.uid : '';
            state.stu_num = data.data ? data.data.stu_num : '';
            state.birth = data.birth;
            state.state = data.data.state;
            let area_code = data.data && data.data.city ? data.data.city.area_code : '';
            state.area_code = area_code ? area_code : '';
            let py_area_code = data.data && data.data.py_data ? data.data.py_data.bindingCode : '';
            state.py_area_code = py_area_code? py_area_code : '';//培优地区码
            let py_area_name = data.data && data.data.py_data ? data.data.py_data.cityName : '';
            state.py_area_name = py_area_name? py_area_name : '';//培优地区名称
            let py_real_name = data.data && data.data.py_data ? data.data.py_data.realname : '';
            state.py_real_name = py_real_name ? py_real_name : "";//培优真实姓名
            let py_grade = data.data && data.data.py_data ? data.data.py_data.grid : '';
            state.py_grade = py_grade ? py_grade : '';//培优年级
            let stu_id = data.data ? data.data.stu_id : '';
            state.stu_id = stu_id ? stu_id : '';
        }
    },
    userReg(state, data) {
        state.name = data.name;
        state.phone = data.phone;
        state.province_id = data.province_id;
        state.city_id = data.city_id;
        state.sex = data.sex;
        state.grade = data.grade;
        state.email = data.email;
        state.birth = data.birth;
    },
    userUpdate(state, data) {
        state.name = data.hasOwnProperty('name') ? data.name : state.name;
        state.headimg = data.hasOwnProperty('head_pic') ? data.head_pic : state.headimg;
        state.phone = data.hasOwnProperty('phone') ? data.phone : state.phone;
        state.province_id = data.hasOwnProperty('province_id') ? data.province_id : state.province_id;
        state.province_name = data.hasOwnProperty('province_name') ? data.province_name : state.province_name;
        state.city_id = data.hasOwnProperty('city_id') ? data.city_id : state.city_id;
        state.city_name = data.hasOwnProperty('city_name') ? data.city_name : state.city_name;
        state.area_code = data.hasOwnProperty('area_code') ? data.area_code : state.area_code;
        state.sex = data.hasOwnProperty('sex') ? data.sex : state.sex; // 1||2
        state.grade = data.hasOwnProperty('grade') ? data.grade : state.grade;
        state.email = data.hasOwnProperty('email') ? data.email : state.email
        state.birth = data.hasOwnProperty('birth') ? data.birth : state.birth;
    },
    updateUName(state, data) {
        // 更新用户名
        state.name = data;
    },
    updateUserImg(state, data) {
        // 更新用户名
        state.headimg = data;
    },
    updateSex(state, data) {
        // 更新性别
        state.sex = data;
    },
    updateProvince(state, data) {
        // 更新省份
        state.province_id = data;
    },
    updateCity(state, data) {
        // 更新城市
        state.city_id = data;
    },
    updateProvinceName(state, data) {
        // 更新省份
        state.province_name = data;
    },
    updateCityName(state, data) {
        // 更新城市
        state.city_name = data;
    },
    updateGrade(state, data) {
    	//更新年级
    	state.grade = data;
    },
    updatePhone(state, data) {
        // 更新手机
        state.phone = data;
    },
    updatePhoneCode(state, data) {
        state.phone_code = data;
    },
    updateMail(state, data) {
        //更新邮箱
        state.email = data;
    },
    updateBirth(state, data) {
        //更新生日
        state.birth = data;
    },
    updateAreaCode(state, data) {
        //更新地区码
        state.area_code = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/userInfo/mutations.js